module.exports = __webpack_public_path__ + "19c6bf208224b71389806bd8ce6e8573.png";